module.exports = __webpack_public_path__ + "img/qrCode_img_pre.87c548cd.png";